import React from 'react';
import PropTypes from 'prop-types';

import Chart from '../../../Chart/Chart.jsx';
import formatLocale from '../../../../utils/formatLocale';
import { svgWidgetDimensions, svgWidgetMargins } from '../config.js';

export default class PriceHistoryWidgetChart extends React.Component {
  getChartConfig(years, prices, formatY, priceHistory) {
    return {
      newDesignGraph: false,
      showGridLines: true,
      svgDimensions: svgWidgetDimensions,
      margins: svgWidgetMargins,
      dx: {
        min: Math.min(...years),
        max: Math.max(...years),
        values: {
          major: years,
          minor: [],
        },
        format: {
          major: (d) => `${d}`,
          minor: () => '',
        },
        tickSize: 20,
        tickLengthOffset: 0,
        orient: 'bottom',
      },
      dy: {
        min: Math.min(...prices),
        max: Math.max(...prices),
        values: {
          major: [],
          minor: [],
        },
        format: {
          major: (d) => `${formatLocale.format(formatY)(d)}`,
          minor: () => '',
        },
        tickSize: 20,
        ticksNumber: 3,
        tickLengthOffset: 30,
        orient: 'left',
        axisLabel: {
          label: '€ / m²',
          transform: 'translate(-40, 15)',
        },
      },
      data: [
        {
          values: priceHistory.map((p) => ({ x: p.year, y: p.price })),
        },
      ],
      isMobile:false
    };
  }

  render() {
    const { priceHistory, commercializationType } = this.props;
    const prices = priceHistory.map((p) => p.price);
    const years = priceHistory.map((p) => p.year);
    const formatY = commercializationType === 'BUY' ? ',d' : ',.2f';
    const chartProps = this.getChartConfig(years, prices, formatY, priceHistory);

    return (
      <>
        <Chart {...chartProps} />
      </>
    );
  }
}

PriceHistoryWidgetChart.defaultProps = {
  showDecimals: false,
};

PriceHistoryWidgetChart.propType = {
  showDecimals: PropTypes.bool,
  svgHeight: PropTypes.number.isRequired,
  svgWidth: PropTypes.number,
  priceHistory: PropTypes.array.isRequired,
  commercializationType: PropTypes.string.isRequired,
};
